// Angular
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Afidium
import { SashaBreadcrumbService } from './sasha-breadcrumb.service';
import { IBreadcrumbItem } from 'libraries/service/breadcrumb/IBreadcrumbItem';
import { SashaEntryPoints } from 'app_sasha/sasha-entry-points';

@Component({
    selector: 'sasha-breadcrumb',
    template: `
        <breadcrumb [items]="getItems()" class="e2e-breadcrumb"></breadcrumb>
    `
})
export class SashaBreadcrumbComponent implements OnInit {

    //////////////////////////////////// CONSTRUCTOR ////////////////////////////////////

    constructor(
        private readonly breadcrumbService: SashaBreadcrumbService,
        private readonly activatedRoute: ActivatedRoute,
    ) {
    }

    //////////////////////////////////// COMPONENT LIFECYCLE HOOKS ////////////////////////////////////

    public ngOnInit(): void {
        console.log('init bc')
        this.breadcrumbService.setContext(this.getContext());
        this.breadcrumbService.setItems();
    }

    //////////////////////////////////// COMPONENT METHODS ////////////////////////////////////

    /**
     * @description returns the breadcrumb items
     */
    public getItems(): IBreadcrumbItem[] {
        return this.breadcrumbService.getItems();
    }

    private getContext(): string {

        //certainly can be improved
        const route = this.activatedRoute.pathFromRoot.map((routeValue: ActivatedRoute) => {
            return routeValue.snapshot.url.toString();
        }).toString().split(',');

        if (route.includes(SashaEntryPoints.processing) && route.includes(SashaEntryPoints.booking)) {
            //if processing is before booking
            if (route.indexOf(SashaEntryPoints.processing) < route.indexOf(SashaEntryPoints.booking)) {
                return SashaEntryPoints.processing;
            } else {
                return SashaEntryPoints.booking;
            }
        } else if (route.includes(SashaEntryPoints.booking)) {
            return SashaEntryPoints.booking;
        } else if (route.includes(SashaEntryPoints.processing)) {
            return SashaEntryPoints.processing;
        } else if (route.includes(SashaEntryPoints.bookingInTicketingReport)) {
            return SashaEntryPoints.bookingInTicketingReport;
        } else if (route.includes(SashaEntryPoints.processingIssuing)) {
            return SashaEntryPoints.processingIssuing;
        } else if (route.includes(SashaEntryPoints.processingCancel)) {
            return SashaEntryPoints.processingCancel;
        } else if (route.includes(SashaEntryPoints.processingVoiding)) {
            return SashaEntryPoints.processingVoiding;
        } else if (route.includes(SashaEntryPoints.ticketingReport)) {
            return SashaEntryPoints.ticketingReport;
        } else if (route.includes(SashaEntryPoints.importBooking)) {
            return SashaEntryPoints.importBooking;
        } else if (route.includes(SashaEntryPoints.processReport)) {
            return SashaEntryPoints.processReport;
        }
    }
}
